import { Component, forwardRef } from '@angular/core';
import { SessionService } from 'src/app/services/session.service';
import { FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';
import { WizardScreenComponent } from 'src/app/shared/wizard.component';
import { AuthenticationType } from 'src/app/services/oidc.factory';
import { CognitoService } from 'src/app/services/cognito.service';

const confirmPasswordValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const confirmCheck = (control.get('newPassword') && control.get('confirmNewPassword') && control.get('newPassword').value != '' && control.get('newPassword').value != control.get('confirmNewPassword').value) ? { passwordNoMatch: true } : null;

  if (confirmCheck) {
    control.get('confirmNewPassword').setErrors({ passwordNoMatch: true });
  }

  return null;
}

@Component({
  selector: 'cw-ci-profile-credentials',
  templateUrl: './profile-credentials.component.html',
  styleUrls: ['./profile-credentials.component.scss'],
  providers: [{provide: WizardScreenComponent, useExisting: forwardRef(() => ProfileCredentialsComponent)}]
})
export class ProfileCredentialsComponent extends WizardScreenComponent {
  public loggedInDirectly: boolean;
  limitExceeded: boolean;

  constructor(_sessionService: SessionService, private _cognitoService: CognitoService) {
    super();
    this.loggedInDirectly = _sessionService.getAuthenticationType() == AuthenticationType.COGNITO;

    this.form = new FormGroup ({
      currentPassword: new FormControl('', [Validators.required]),
      newPassword: new FormControl('', [Validators.required]),
      confirmNewPassword: new FormControl('', [Validators.required]),
    }, [confirmPasswordValidator]);
  }

  onLoad() {
    this.form.reset();
    super.onLoad();
  }

  onSave() {
    if (this.isValid()) {
      this.showSpinner('Saving...');

      const oldpassword = this.form.controls.currentPassword.value;
      const newPassword = this.form.controls.newPassword.value;

      this._cognitoService.changePassword(oldpassword, newPassword).then(user => {
        this.hideSpinner();
        this.form.controls.currentPassword.reset();
        this.form.controls.newPassword.reset();
        this.form.controls.confirmNewPassword.reset();
        this.showMessage('Your password has been updated.');
        super.onSave();
      }, err => {
        console.log('Failed to save user', err);
        this.hideSpinner();
        if(err.code == 'NotAuthorizedException' ||
          (err.code == 'InvalidParameterException' && err.message.includes('previousPassword'))) {
          this.form.controls.currentPassword.setErrors({ incorrectPassword: true });
        } else {
          this.showMessage('Unable to change password: ' + err.message);
        }
      });
    }
  }
}